<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="isCreateRole()"
              class="bg_l_green"
              v-has-permission="permission160"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewRole") }}
            </vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('RoleName'), sort: 'Name' },
                { title: $t('EnglishName') },
                { title: $t('IsActive'), sort: 'IsActive' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 24%">
                  {{ row.name }}
                </td>
                <td style="width: 24%">
                  {{ row.englishName ? row.englishName : "---" }}
                </td>
                <td style="width: 7%">
                  <vs-checkbox
                    v-model="row.isActive"
                    disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 15%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 30%">
                  <div
                    class="w-full flex gap-2 justify-center flex-wrap items-center"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="simple-bordered-btn mx-0"
                      @click.prevent="isUsersPopup(row)"
                      v-has-permission="permission158"
                      >{{ $t("Users") }}</vs-button
                    >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="simple-bordered-btn mx-0"
                      @click.prevent="isPermissionPopup(row)"
                      v-has-permission="permission157"
                      >{{ $t("Permissions") }}</vs-button
                    >
                    <div class="flex items-center justify-center gap-2">
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click.prevent="isEditRole(row)"
                        class="d-inline"
                        v-has-permission="permission161"
                      ></vs-button>
                      <vs-button
                        radius
                        color="danger"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.prevent="isDeleteRole(row.id)"
                        class="d-inline"
                        v-has-permission="permission159"
                      ></vs-button>
                    </div>
                  </div>
                </td>
              </template>
            </data-grid>
            <create-popup
              :show="showCreatePopup"
              @finish="onfinish"
              @close="closeCreatePopup"
            ></create-popup>
            <modify-popup
              :show="showModifyPopup"
              :roleCurrent="roleCurrent"
              @finish="onfinish"
              @close="closeModifyPopup"
            ></modify-popup>
            <users-popup
              :show="onUsersPopup"
              :urlApiForUserList="urlApiForUserList"
              :roleCurrent="roleCurrent"
              @finish="onfinish"
              @close="closeUsersPopup"
            ></users-popup>
            <permission-popup
              :show="onPermissionPopup"
              @finish="onfinish"
              :roleCurrent="roleCurrent"
              :permissionModel="permissionModel"
              @close="closePermissionPopup"
            ></permission-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.vs-checkbox {
  margin: 0 auto;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
import CreatePopup from "./CreatePopup.vue";
import ModifyPopup from "./ModifyPopup.vue";
import UsersPopup from "./UsersPopup.vue";
import PermissionPopup from "./PermissionPopup.vue";
export default {
  name: "usermanagement-Roles-Index",
  components: {
    ModifyPopup,
    CreatePopup,
    DataGrid,
    UsersPopup,
    PermissionPopup,
  },
  data() {
    return {
      permission157: "GetUsersByRoleId",
      permission158: "GetAllPermissionsByRoleId",
      permission159: "DeleteRole",
      permission160: "CreateRole",
      permission161: "ModifyRole",
      showModifyPopup: false,
      showCreatePopup: false,
      gridDataSource: {
        type: "app",
        service: "IdentityAccess/api/RolesQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      onUsersPopup: false,
      onPermissionPopup: false,
      permissionModel: [],
      urlApiForUserList: [],
      roleCurrent: {},
    };
  },
  computed: {
    ...mapGetters({
      rolePermissions: "role/details",
    }),
  },
  methods: {
    ...mapActions({
      removeRole: "role/remove",
      fetchByRoleId: "role/fetchByRoleId",
    }),
    isCreateRole() {
      this.showCreatePopup = true;
    },
    isEditRole(role) {
      this.roleCurrent = role;
      this.showModifyPopup = true;
    },
    isDeleteRole(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeRole(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    isPermissionPopup(role) {
      this.fetchByRoleId(role.id).then(() => {
        this.permissionModel = JSON.parse(JSON.stringify(this.rolePermissions));
      });
      this.roleCurrent = role;
      this.onPermissionPopup = true;
    },
    isUsersPopup(role) {
      this.urlApiForUserList =
        "IdentityAccess/api/RolesQuery/" + role.id + "/Users";
      this.roleCurrent = role;
      this.onUsersPopup = true;
    },
    closeCreatePopup() {
      this.showCreatePopup = false;
    },
    closeModifyPopup() {
      this.showModifyPopup = false;
    },
    closePermissionPopup() {
      this.onPermissionPopup = false;
    },
    closeUsersPopup() {
      this.onUsersPopup = false;
    },
    onfinish() {
      this.closeCreatePopup();
      this.closeModifyPopup();
      this.closePermissionPopup();
      this.closeUsersPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
